import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AV from "leancloud-storage";
import "./plugins/element.js";

Vue.config.productionTip = false;

enum APPDATA {
    license='wxc534f9ed8a9993da',
    templateType='1'
}

Vue.prototype.app=APPDATA;


var APP_ID = 'vF4UkeiM0SozsFEr3vjmKCNm-gzGzoHsz';
var APP_KEY = 'jmUElL3YoHqUfFtkDroWbUca';

AV.init({
	appId: APP_ID,
	appKey: APP_KEY,
	serverURLs: 'https://avoscloud.com'
});

router.beforeEach((to, from, next) => {
	console.log(AV.User.current())
	if (AV.User.current()) {
		next();
	} else {
		if (to.path !== "/login") {
			next({ path: "/login" });
		} else {
			next();
		}
	}
});

// function loginWithAuth () {
// 	 AV.User.logIn('FEC-Admin', '12345678').then(function(user) {
// 	 	console.log(user);
     
//       }).catch(alert)
 
// }
// loginWithAuth();
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");